export default __webpack_public_path__ + "static/media/GT-Ultra-Standard-Ultra.3c7c7aae.woff2";